import { AnyAction } from 'redux';
import { DataForDashboard, GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { App, VermietetesObjekt, VermietetesObjektEnum } from '@ps20-frontend/frontend-models';
import { RsActions } from '../rsActions';
import { IAppState } from '../appState';

export const vermieteteObjekteReducer = function (
  sectionState: Array<VermietetesObjekt> = null,
  action: AnyAction,
  appState: IAppState,
): Array<VermietetesObjekt> {
  switch (action.type) {
    case RsActions.VERMIETETE_OBJEKTE_UPDATED: {
      const vermieterModalVermieteteObjekte =
        appState.transientState.vermieterModalVermieteteObjekte;
      return vermieterModalVermieteteObjekte.map(value => {
        if (value.grundstueckBebaut === VermietetesObjektEnum.BEBAUT) {
          return {
            plz: value.plz,
            ort: value.ort,
            strasse: value.strasse,
            hausnummer: value.hausnummer,
            grundstueckBebaut: VermietetesObjektEnum.BEBAUT,
            wohneinheiten: value.wohneinheiten,
            bruttojahresmieteWohneinheiten: value.bruttojahresmieteWohneinheiten,
            gewerbeeinheiten: value.gewerbeeinheiten,
            bruttojahresmieteGewerbeeinheiten: value.bruttojahresmieteGewerbeeinheiten,
            stellplaetze: value.stellplaetze,
            bruttojahresmieteStellplaetze: value.bruttojahresmieteStellplaetze,
            instanzIdGarage: value.instanzIdGarage,
            instanzIdGewerbe: value.instanzIdGewerbe,
            instanzIdWohnung: value.instanzIdWohnung,
            auslaendischeAdresse: value.auslaendischeAdresse,
          };
        }
        if (value.grundstueckBebaut === VermietetesObjektEnum.UNBEBAUT) {
          return {
            plz: value.plz,
            ort: value.ort,
            strasse: value.strasse,
            hausnummer: value.hausnummer,
            grundstueckBebaut: VermietetesObjektEnum.UNBEBAUT,
            grundstueckFlaeche: value.grundstueckFlaeche,
            flurstueckNummer: value.flurstueckNummer,
            auslaendischeAdresse: value.auslaendischeAdresse,
          };
        }
        return null;
      });
    }
    case GlobalActions.IN_DASHBOARD_UEBERNEHMEN: {
      const actionPayload: DataForDashboard = action.payload;
      if (actionPayload.appId === App.RS) {
        if (actionPayload.selectZusatzoptionen.every(value => value.id !== 'vermieter')) {
          return null;
        }
      }
      return sectionState;
    }
    case RsActions.OVERWRITE_VERMIETETE_OBJEKTE: {
      return action.payload;
    }
    default:
      return sectionState;
  }
};
